<template>
  <div class="fcc-icons" @scroll="onScroll()">
    <div class="icons">
      <div class="icon-row" v-for="(iconRow, index) in icons" :key="index">
        <div
          class="icon"
          v-for="(item, index) in iconRow"
          :key="index"
          :data-aos-delay="index*200"
          data-aos="zoom-in-up"
          data-aos-duration="1000"
          data-aos-easing="ease-out-cubic"
          :style="'width:calc(100% / ' + iconRow.length + ')'"
        >
          <img :src="require(`@/assets/icons/facts/${item.icon}`)" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icons: Array
  }
};
</script>

<style lang="scss" scoped>
.fcc-icons {
  background-image: linear-gradient(
    270deg,
    rgba(5, 17, 42, 0.84) 52%,
    rgba(0, 0, 0, 0.84) 100%
  );
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  text-align: center;
  pointer-events: none;
  .icon-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon {
    display: inline-block;
    padding: 0 15px;
    flex-grow: 1;
    box-sizing: border-box;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  .icons {
    position: relative;
    max-width: 1500px;
    margin: 50px auto;
    padding: 0 50px;
    padding-top: 12%;
  }
}
@media (max-width: 1000px) {
  .fcc-icons {
    pointer-events: all;
    .icon-row {
      display: block;
    }
    .icon {
      display: block;
      width: 100% !important;
    }
  }
}
</style>